<template>
  <div class="root">
    <div>
      <bar-chart
        class="print-hide"
        :data="specialty"
        :dataset="{ borderWidth: 0 }"
        :download="true"
        :colors="['rgba(27, 58, 89, 1)']"
        height="300px"
        width="100%"
        :library="chartOptions"
      />

      <ul class="print-data-list cells print-only-inline">
        <li v-for="(v, k) in specialty" :key="k">
          {{ k }} <strong>{{ v }}%</strong>
          <span class="bar-container">
            <span class="bar" :style="{ width: (100 * v) / 100 + '%' }"></span>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';
import Vue from 'vue';
import Chartkick from 'vue-chartkick';

Vue.use(Chartkick.use(Chart));

const hiddenStruggles = ['Stress', 'None', 'Family Distress'];

export default {
  name: 'StudentConcernsChart',

  props: {
    data: {
      type: Array,
      default: () => null
    },
    studentCount: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      chartOptions: {
        animation: {
          easing: 'easeOutQuad',
          duration: 300
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        scales: {
          yAxes: [
            {
              gridLines: { display: false },
              ticks: { fontSize: 15, fontColor: '#6B6E88' }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                fontSize: 15,
                fontColor: '#6B6E88',
                callback(value) {
                  return `${value}%`;
                }
              }
            }
          ]
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: ({ value }) => `${value}%`
          }
        }
      }
    };
  },

  computed: {
    specialty() {
      if (!this.data) {
        return {};
      }

      return this.data
        .filter((e) => hiddenStruggles.indexOf(e.answer_text) < 0)
        .reduce((a, e) => {
          a[e.answer_text] = Math.round(
            (e.number_of_responses / this.studentCount) * 100
          );
          return a;
        }, {});
    }
  }
};
</script>

<style lang="scss" scoped>
.root {
  padding: 0 2.45rem;
}
</style>
